import { useDialog } from "@/client/stores/dialog";
import {
  Badge,
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  ScrollArea,
} from "@reactive-resume/ui";
import { CheckCircleIcon, XCircleIcon } from "@phosphor-icons/react";
import { useCoupon } from "@/client/services/coupon/coupon";
import { TypeCoupon } from "@reactive-resume/utils";
export const GetCouponDialog = () => {
  const { isOpen, close, payload } = useDialog<{ id: string }>("get-coupon");
  const { coupon } = useCoupon(payload?.item?.id ?? "");
  if (coupon) {
    return (
      <Dialog open={isOpen} onOpenChange={close}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Details de L'utilisateur</DialogTitle>
          </DialogHeader>
          <div className="grid-row-5 grid grid-cols-2 gap-2">
            <div className="border-secondary border-b-2 font-bold">Code</div>
            <div className="border-secondary border-b-2"> {coupon.code} </div>
            <div className="border-secondary border-b-2 font-bold">Reduction</div>
            <div className="border-secondary border-b-2">{coupon.reduction}</div>
            <div className="border-secondary border-b-2 font-bold">Type</div>

            {coupon.type == TypeCoupon.Promo ? (
              <>
                <div className="border-secondary border-b-2">
                  <Badge variant="warning">Promotion</Badge>
                </div>
              </>
            ) : (
              <>
                <div className="border-secondary border-b-2">
                  <Badge variant="success">Reduction</Badge>
                </div>
              </>
            )}
            <div className="border-secondary border-b-2 font-bold">Valide du</div>
            <div className="border-secondary border-b-2">
              {new Date(coupon.startDate).toDateString()}
            </div>
            <div className="border-secondary border-b-2 font-bold">Jusau'au</div>
            <div className="border-secondary border-b-2">
              {new Date(coupon.endDate).toDateString()}
            </div>

            <div className="border-secondary border-b-2 font-bold">Statut</div>
            <div className="border-secondary border-b-2">
              {coupon.status == 0 && <CheckCircleIcon size={32} color="green" />}
              {coupon.status == 1 && <XCircleIcon size={32} color="red" />}
            </div>
          </div>
        </DialogContent>
        <DialogFooter></DialogFooter>
      </Dialog>
    );
  }
};
